var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TableConfigBase } from '../table-config-base';
/**
 * An config containing properties for table
 */
var TableConfig = /** @class */ (function (_super) {
    __extends(TableConfig, _super);
    function TableConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TableConfig;
}(TableConfigBase));
export { TableConfig };
//# sourceMappingURL=table-config.js.map